import {
  renderCardSection,
  renderAnyHitDetails,
} from "./WatchlistDataReviewUtils.js";
import { getWatchlistData } from "./watchlistUtils";
import renderMofsHitDetails from './MofsHitDetails';

const WatchlistDataReview = ({ data, onActionSelect, onActionUndo }) => {
  const watchlistData = getWatchlistData(data);
  return (
    <>
      {renderCardSection(
        watchlistData.fakeEmailDomains,
        "Fake e-mail domains",
        renderAnyHitDetails,
        <>
          SignalCheck — The Hub maintains a list of fake email domains that were
          involved in paper mill activities. Domains are sourced from publishers
          and Anna Abalkina. A red flag indicates that a match was found.
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.fakeAffiliationNames,
        "Fake affiliation names",
        renderAnyHitDetails,
        <>
          SignalCheck — The STM Integrity Hub maintains a list of fake email domains
          and institution names that were involved in paper mill activities. A red
          flag indicates that a match was found.
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.fakeNamesOrEmailAddresses,
        "Fake names or email addresses",
        renderAnyHitDetails,
        <>
          SignalCheck — The STM Integrity Hub maintains a list of fake names or
          email addresses that were involved in paper mill activities. A red flag
          indicates that a match was found.
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.disposableEmailDomains,
        "Disposable e-mail domains",
        renderAnyHitDetails,
        <>
          SignalCheck — The Hub maintains a list of fake email domains that were
          involved in paper mill activities. Domains are sourced from publishers
          and Anna Abalkina. A red flag indicates that a match was found.
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.metadataSuspects,
        "Metadata suspects",
        renderAnyHitDetails,
        <>
          SignalCheck – The STM Integrity Hub maintains a list of suspect names that may occur
          in WORD file metadata. These suspect names were identified by participating publishers.
        </>,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.manuscriptsOfferedForSale,
        "Manuscripts offered for sale",
        renderMofsHitDetails,
        null,
        onActionSelect,
        onActionUndo,
        data
      )}
      {renderCardSection(
        watchlistData.suspectArticles,
        "Suspect articles",
        renderAnyHitDetails,
        null,
        onActionSelect,
        onActionUndo,
        data
      )}
    </>
  );
};

export default WatchlistDataReview;
